export const Tariffs = {
  cardsInfo: [
    {
      title: 'CRIF',
      descriptions: ['zawiera informacje otrzymane tylko <b> od firm finansowych </b>',
        'główny nacisk na <b> ostatnie zmiany w historii kredytowej </b>',
      ],
      tariffs: [
        {
          price: '29',
          desc: 'oszczędzasz 50%',
          quantity: 'zamów 4 raporty za 60 zl'
        },
      ],
      withChecbox: true,
      oneTariff: false
    },

    {
      title: 'BIK',
      descriptions: ['zawiera informacje o pożyczkach w <b> instytucjach bankowych i firmach finansowych </b>',
        'zawiera informacje historyczne, które gromadziliście przez lata w swojej historii kredytowej',
      ],
      tariffs: [
        {
          price: '29',
          desc: 'oszczędzasz 50%',
          quantity: 'zamów 4 raporty za 60 zl'
        },
      ],
      withChecbox: true,
      oneTariff: false
    },

    {
      title: 'BIK & CRIF',
      descriptions: ['maksymalną ilość informacji <b>z różnych źródeł</b> ',
        'przewiduje jednorazowy raport na podstawie danych <b>z BIK i CRIF</b>',
        '<b>dla aktywnych użytkowników</b> pożyczek i dla tych, którzy zawsze trzymają rękę na pulsie',
      ],
      tariffs: [
        {
          price: '39',
          desc:'oszczędzasz 30% ',
          quantity: 'zamów raport BIK & CRIF',

        }
      ],
      withChecbox: false,
      oneTariff: true
    }, 
  ]
}



// WEBPACK FOOTER //
// src/js/controllers/bikfish/tariffs.js